import { pick } from 'ramda';

export default pick([
  'autofocus',
  'disabled',
  'form',
  'formaction',
  'formenctype',
  'formmethod',
  'formnovalidate',
  'formtarget',
  'name',
  'type',
  'value',
]);
